<template>
    <div>
        <form @submit.prevent="onSubmit" id="code_form" class="disp-none mt-5">
            <vue-recaptcha
                v-if="captchaDriver === 'recaptcha'"
                ref="verifyCode"
                @verify="onVerify"
                @expired="onExpired"
                size="invisible"
                :sitekey="sitekey"
                :loadRecaptchaScript="true"
            >
            </vue-recaptcha>

            <arcaptcha-vue
                v-if="captchaDriver === 'arcaptcha'"
                ref="arcaptchaVerify"
                :site_key="arCaptchaKey"
                :invisible="true"
                :callback="onArcaptchaSuccess"
                :expired_callback="onArcaptchaExpired"
                :error_callback="onArcaptchaError"
            />

            <div class="form-field text-center" style="direction: rtl">
                <input
                    :placeholder="$t('auth.placeholder.code')"
                    name="code"
                    id="code"
                    :value="value"
                    @input="$emit('input', $event.target.value)"
                    type="text"
                />
            </div>
            <div class="login-footer" style="margin-top: 15px">
                <button type="submit" v-if="!loading" id="verify_submit">
                    {{ $t('auth.btn.verify') }}
                </button>
                <button v-else type="submit" id="verify_submit">
                    <span class="spinner-border"></span>
                </button>
            </div>
            <div
                class="login-footer disp-none"
                style="margin-top: 15px; direction: rtl"
                id="resend_code_section"
            >
                <span class="kt-login__account-msg">
                    {{ $t('auth.code_not_received') }} </span
                >&nbsp;&nbsp;
                <span id="resend_counter_div" class="kt-login__account-msg">
                    <span>
                        {{ $t('auth.title.resend_code_in') + ' ' }}
                    </span>
                    <span id="timer_span">60</span>
                    <span>
                        {{ ' ' + $t('auth.title.second') }}
                    </span>
                </span>
                <span
                    class="mx-2 make-hover disp-none"
                    style="cursor: pointer !important"
                    id="resend_btn"
                    @click="resendCode"
                >
                    {{ $t('auth.btn.resend') }}
                </span>
            </div>
        </form>
    </div>
</template>
<script>
import { authService } from '@/common/api.service';
import $ from 'jquery';
import VueRecaptcha from 'vue-recaptcha';
import { reCaptchaKeys } from '@/constants/getRecaptchaKey';
import { arCaptchaKeys } from '@/constants/getArCaptchaKey';
import { getCaptchaDriver } from '@/constants/getCaptchaDriver';
import { KTApp } from '@/plugins/core/app';
import ArcaptchaVue from 'arcaptcha-vue';

export default {
    name: 'VerifyCode',
    props: ['phone', 'value'],
    components: {
        VueRecaptcha,
        ArcaptchaVue
    },

    data() {
        return {
            recaptcha_verified: false,
            g_recaptcha_response: '',
            sitekey: reCaptchaKeys,
            arCaptchaKey: arCaptchaKeys,
            captchaDriver: getCaptchaDriver,
            code: null,
            login_event: null,
            arcaptchaToken: '',
            arcaptchaVerified: false,
            loading: false
        };
    },

    methods: {
        onSubmit: function (e) {
            this.executeCaptcha();
            this.login_event = e;
        },

        async executeCaptcha() {
            this.loading = true;
            if (this.captchaDriver === 'recaptcha') {
                await this.$refs.verifyCode.execute();
            } else if (this.captchaDriver === 'arcaptcha') {
                this.arcaptchaVerified = false;
                this.arcaptchaToken = '';
                await this.$refs.arcaptchaVerify.execute();
            } else if (!this.captchaDriver || this.captchaDriver === 'none') {
                this.verifyCode();
            }
        },

        onVerify(response) {
            this.recaptcha_verified = true;
            this.g_recaptcha_response = response;
            this.verifyCode(this.login_event);
        },

        onArcaptchaSuccess(token) {
            this.arcaptchaToken = token;
            this.arcaptchaVerified = true;
            this.verifyCode(this.login_event);
        },

        onArcaptchaExpired() {
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
            this.loading = false;
        },

        onArcaptchaError(error) {
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
            this.loading = false;
        },

        onExpired() {
            this.recaptcha_verified = false;
            this.loading = false;
        },

        resetCaptcha() {
            if (this.captchaDriver === 'recaptcha') {
                this.$refs.verifyCode.reset();
            } else if (this.captchaDriver === 'arcaptcha') {
                this.$refs.arcaptchaVerify.reset();
                this.arcaptchaVerified = false;
                this.arcaptchaToken = '';
            }
        },

        verifyCode() {
            let btn = $('#verify_submit');
            let form = $('#code_form');
            let change_pass = $('#change_pass');
            let before_code_verify = $('#before_code_verify');
            let params = {
                phone: this.phone,
                code: this.value
            };

            if (this.captchaDriver === 'recaptcha') {
                params['g-recaptcha-response'] = this.g_recaptcha_response;
            } else if (this.captchaDriver === 'arcaptcha') {
                params['g-recaptcha-response'] = this.arcaptchaToken;
            }

            form.validate({
                ignore: '.ignore',
                rules: {
                    code: {
                        required: true
                    }
                }
            });

            if (!form.valid()) {
                this.loading = false;
                return;
            }

            KTApp.progress(btn);
            this.resetCaptcha();
            authService
                .verifyCode(params)
                .then((response) => {
                    before_code_verify.addClass('disp-none');
                    change_pass.removeClass('disp-none');
                })
                .catch((error) => {
                    this.resetCaptcha();
                    if (error.response.data.data)
                        form.validate().showErrors(error.response.data.data);
                    else
                        this.showMsg(
                            form,
                            'danger',
                            error.response.data.message
                        );
                })
                .finally(() => {
                    this.loading = false;
                    KTApp.unprogress(btn);
                });
        },

        resendCode() {
            this.$emit('resendCode');
        }
    }
};
</script>
<style scoped></style>